import { render, staticRenderFns } from "./DocumentPreviewTableRow.vue?vue&type=template&id=ed7dd098&scoped=true&"
import script from "./DocumentPreviewTableRow.vue?vue&type=script&lang=ts&"
export * from "./DocumentPreviewTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentPreviewTableRow.vue?vue&type=style&index=0&id=ed7dd098&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7dd098",
  null
  
)

export default component.exports